import React from 'react';
import {Box} from '@mui/material';

import { appTheme } from './theme';

/**
 * Simple component used to provide a default title for AuthHeader component
 */
const DefaultTitle: React.FC = () => {
  return (
    <>
      Bem-vindo à{' '}
      <Box
        component="span"
        sx={{
          color: appTheme.palette.primary.light,
          fontWeight: 700,
        }}
      >
        StreamFin
      </Box>
    </>
  );
};

export default DefaultTitle;